export enum systemClass {
  MatchHeight = "match-height",
  MatchWidth = "match-width"
}

export enum resourceName {
  GOLD = "gold",
  GRAIN = "grain",
  FOOD = "food",
  STONE = "stone",
  BRICKS = "bricks",
  IRON = "iron",
  WEAPONS = "weapons",
  MANA = "mana"
}

export const MARKETABLE_RESOURCES = [
  resourceName.GRAIN,
  resourceName.STONE,
  resourceName.BRICKS,
  resourceName.IRON,
  resourceName.WEAPONS,
  resourceName.MANA
]

export const RESOURCE_IDS: {[key: string]: number} = {
  [resourceName.GOLD]: 1,
  [resourceName.GRAIN]: 2,
  [resourceName.FOOD]: 3,
  [resourceName.STONE]: 4,
  [resourceName.BRICKS]: 5,
  [resourceName.IRON]: 6,
  [resourceName.WEAPONS]: 7,
  [resourceName.MANA]: 8
}

export enum tileType {
  INDUSTRIAL = 1,
  VILLAGE = 2,
  CITY = 3
}

export const TILE_TYPE_NAMES: {[key:number]: string} = {
  [tileType.INDUSTRIAL]: "industrial",
  [tileType.VILLAGE]: "village",
  [tileType.CITY]: "city",
}

export enum GENERAL_TYPE {
  SOLDIER = 1,
  MAGE = 2,
  THIEF = 3,
  ECONOMIST = 4
}

export const GENERAL_TYPE_NAME: {[key: number]: string} = {
  1: "Soldier",
  2: "Mage",
  3: "Thief",
  4: "Econome",
}

export enum ARMY_UNITS {
  E1 = "E1",
  E2 = "E2",
  E3 = "E3",
  SIEGE_ENGINE = "s_engines",
  DRAGON = "DRAGON"
}

export enum SLOT_CHAIN {
  ARMY = 6
}

export enum TECHNOLOGIES {
  AGRICULTURE = "Agriculture",
  MINING = "Mining",
  CONSTRUCTION = "Construction",
  TRADE = "Trade",
  ALCHEMY = "Alchemy",
  SMITHING = "Smithing",
  NATURE = "Nature"
}

export enum BANNER_NAMES {
  LEFT_FLANK = "Left flank",
  CENTER = "Center",
  RIGHT_FLANK = "Right flank",
  BACKUP = "Backup",
}

export const BACKUP_ORDERS = [
  "Replace defeated",
  "Support winning",
  "Support even",
  "Support losing",
]

export enum BATTLE_TACTICS {
  PHALANX = 1,
  OBLIQUE_ORDER = 2,
  TULUGHAMA = 3,
  CHARGE = 4,
}

export enum MAGIC_MODE {
  NORMAL,
  CORE_OVERLOAD,
  PROLONGED_DURATION,
  SPELL_RESISTANCE
}

export const MONTH_NAMES = [
  null,
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export enum NEWS_DETAIL {
  EspionageWeakness = 3,
  EspionageTurns = 5,
  EspionageFarmers = 6,
  EspionageStoneMiners = 7,
  EspionageIronMiners = 8,
  EspionageDruids = 9,
  EspionageBakers = 10,
  EspionageMasons = 11,
  EspionageSmiths = 12,
  EspionageTraders = 13,
  EspionageAlchemists = 14,
  EspionageSerfs = 15,
  EspionageE1 = 16,
  EspionageE2 = 17,
  EspionageE3 = 18,
  EspionageSieges = 19,
  EspionageDragons = 20,
  EspionageGenerals = 21,
  AttackE1Loses = 22,
  AttackE2Loses = 23,
  AttackE3Loses = 24,
  AttackEnginesLoses = 25,
  DefenceE1Loses = 26,
  DefenceE2Loses = 27,
  DefenceE3Loses = 28,
  DefenceSiegeLoses = 29,
  CivilLoses = 30,
  GeneralExpGain = 31,
  OpponentBannerInitStats = 32,
  OpponentBannerFinishStats = 33,
  BuildingDamage = 34,
  StolenResources = 35,
  ActionPower = 41,
  EmpoweredSpell = 42,
  BattlegroundPosition = 44,
  BannerResult = 45,
  BackupDetail = 46,
  SupportDetail = 47,
  RangePhaseDetail = 48,
  MeleeTurnsDetails = 49,
  BannerInitStats = 50,
  SupportedGoverny = 51,
  BannerFinishStats = 52,
  SiegePhaseDetail = 53,
  SiegeDamagedBuildings = 54,
  OpponentSupportedGoverny = 62,
  OpponentSupportDetail = 63,
  OpponentBackupDetail = 64,
  ScorchedEarthDamage = 65,
  VirtualBanner = 66,
  VirtualOpponentBanner = 67,
  DestroyerBuildingDamage = 68,
  BattleRound = 69,
  IdleBanners = 70,
  TransferStarted = 71,
  EngagedInBattle = 72,
  FightingBanners = 73,
  DefeatedBanners = 74,
}

export enum UPGRADES {
  OutlinePalace = 1,
  InstantMarket = 7,
  ResetGeneral = 12,
  ResetDevelopment = 13,
  PurchaseGeneral = 14,
  MarketSlot = 18,
  ArmyEmperorTent = 19,
  MagicEmperorTent = 20,
  ThievesEmperorTent = 21,
  ResetSpells = 22
}

export enum CHAT_TYPE {
  Board = 1,
  Public = 2,
  Alliance = 3
}

export enum POST_CONTEXT {
  Chat = "chat",
  Mail = "mail"
}

export enum CONTENT_CONTEXT {
  Alliance = "alliance",
  Governorate = "governorate",
  World = "world"
}
